import React, { useContext } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { AppContext } from '../App.context'
import PrivateRoute from './PrivateRoute'

export default function ProtectedRoute({ children }) {
  const { appState } = useContext(AppContext)
  const location = useLocation()
  
  if (appState.role === 'user' || appState.role === 'guest') {
    return <Navigate to="/checkin" replace state={{ from: location }} />
  }

  return (
    <PrivateRoute>
      {children ?? <Outlet />}
    </PrivateRoute>
  )
}